import { styled } from 'stitches.config'
import { SixRecipesContainer, Recipe } from 'features/Recipes/components/SixRecipes/SixRecipes.styles'

export const ExploreRoot = styled('div', {
  background: '$tertiary-200',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  overflow: 'hidden',
  position: 'relative',
})

export const RecipesWrapper = styled(SixRecipesContainer, {
  paddingTop: 0,
})

export const RecipePill = styled(Recipe, {
  paddingRight: 0,
  paddingLeft: 0,
  justifyContent: 'center',
})

export const RecipesContainer = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '0px',

  '@bp2': {
    gap: '32px'
  }
})

export const RecipeBadge = styled('div', {
  position: 'relative',
  width: '160px',
  margin: 'auto',
  cursor: 'pointer',
  display: 'none',

  '@bp2': {
    display: 'block'
  }
})

export const WaveWrapper = styled('div', {
  position: 'relative',
  display: 'block',
  width: '1920px',
  height: 'auto',

})

export const WfrWrapper = styled('div', {
  position: 'absolute',
  width: '240px',
  top: '-61px',
  left: 0,
  right: 0,
  margin: 'auto',
  zIndex: 2,
  display: 'none',
  '@bp3': {
    display: 'block'
  }
})

export const TitleWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto',
  width: '100px',
  '@bp3': {
    width: '100%',
  }
})

export const BorderWrapper = styled('div', {
  background: '$tertiary-200',
  paddingBottom: '40px',
  position: 'relative',

  '@bp3': {
    paddingBottom: '130px'
  }
})